import React, { useState, useEffect } from 'react';
import ProfileDetailForm from './profile_detail_form';
import axios from 'axios';
import Loader from '../../../../components/loader.jsx';
import compressImage from '../../../../lib/image_compressor.js';

const Edit = (props) => {
  const [profileData, setProfileData] = useState(props.profileData);

  const [imagePreview, setImagePreview] = useState(props.profileData.avatar_thumb || '');
  const [selectedImage, setSelectedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleImageChange = async (e) => {
    let file = e.target.files[0];
    if (file) {
      file = await compressImage(file);
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const toProfilePage = () => {
    location.href = `/member/profile/${props.memberId}`;
  };

  const PreferenceChoose = () => {
    location.href = `/preferences`;
  };
  
  const handleSubmit = () => {
    setIsLoading(true);
    const formData = new FormData();
    Object.keys(profileData).map((key) => formData.append(`profile[${key}]`, profileData[key]));

    if (selectedImage) {
      formData.append('profile[avatar]', selectedImage);
    }

    axios
      .post('/api/profile/update', formData)
      .then(() => {
        alert('保存しました');
        window.location.href = `/member/profile/${props.memberId}`;
      })
      .catch((error) => {
        console.error('Error saving data:', error);
        alert('保存に失敗しました');
      })
      .finally(() => {
        setIsLoading(false);
    });
  };

  return (
    <div id="edit-view">
      {/* プロフィール画像 */}
      <div className="container col-md-8 col-lg-6 mt-3">
        <div
          id="img_field"
          className="bg-white d-flex justify-content-center align-items-center rounded-circle mx-auto"
          style={{ width: '100px', height: '100px' }}
          onClick={() => document.getElementById('upfile').click()}
        >
          {imagePreview ? (
            <img
              src={imagePreview}
              alt="プロフィール画像"
              style={{ objectFit: 'cover', width: '100%', height: '100px' }}
              className="rounded-circle"
            />
          ) : (
            <img
              src="/assets2019/img/icon_camera.svg"
              alt="デフォルトプロフィール画像"
              style={{ width: '32px', height: '32px' }}
            />
          )}
        </div>
        <input
          type="file"
          id="upfile"
          style={{ display: 'none' }}
          accept="image/jpg,image/jpeg,image/png,image/gif"
          onChange={handleImageChange}
        />
      </div>

      <div className="mt-3">
        <ProfileDetailForm formData={profileData} onDataChange={setProfileData} />
      </div>
      
      <div className="text-center mt-4 mb-4">
        {/* ローディング */}
        {isLoading && (
          <div className="d-flex justify-content-center align-items-center my-4">
            <Loader isActive={true} />
          </div>
        )}
        {/* 登録ボタン */}
        <div className="text-center mt-4 mb-4">
          <button
            onClick={toProfilePage}
            className="btn"
            style={{
              backgroundColor: 'gray',
              color: 'white',
              marginRight: '12px',
              padding: '12px 40px',
              borderRadius: '10px',
              fontSize: '16px',
              border: 'none',
            }}
          >
            戻る
          </button>
          <button
            onClick={handleSubmit}
            className="btn"
            style={{
              backgroundColor: '#FF4D5B',
              color: 'white',
              padding: '12px 40px',
              borderRadius: '10px',
              fontSize: '16px',
              border: 'none',
            }}
          >
            登録
          </button>
        </div>
        {/* お好み条件の登録 */}
        <div className="text-center mb-3 pt-3">
          <h3 
            className="mb-4"
            style={{fontSize: '16px'}}>
              お好み条件の設定を変更したい場合は、一度、上記の項目の登録を行ってから、下のボタンから変更を行ってください
          </h3>
          <button
            onClick={PreferenceChoose}
            className="btn"
            style={{
              backgroundColor: '#FFFFFF',
              color: '#FF4D5B',
              padding: '10px 30px',
              borderRadius: '10px',
              fontSize: '14px',
              border: '2px solid #FF4D5B',
              textDecoration: 'none',
            }}
          >
            お好み条件の設定はこちら
          </button>
        </div>
      </div>
    </div>
  );
};

export default Edit;
